import { render } from "./SecurityCategories.vue?vue&type=template&id=c1452be8&scoped=true"
import script from "./SecurityCategories.vue?vue&type=script&lang=js"
export * from "./SecurityCategories.vue?vue&type=script&lang=js"

import "./SecurityCategories.vue?vue&type=style&index=0&id=c1452be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1452be8"]])

export default __exports__